import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { DocumentEmailBannerProps } from "models/propTypes/documentDraftPropTypes";
import { FAQConstants } from "utils/constants";
//#endregion
//#region components
import DocumentDraftReportBanner from "./banner";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const DocumentEmailBanner: React.FC<DocumentEmailBannerProps> = ({ userEmail, useFullWidth }) => {
  return (
    <DocumentDraftReportBanner
      showImage
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.DocumentEmailBannerTitle)}
      subTitle={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.DocumentDraft.DocumentEmailBannerSubTitle
      )}
      userEmail={userEmail}
      readMoreInfo={{
        url: `${FAQConstants.FAQUrl}/${FAQConstants.ArticleDocumentEmailUrl}`,
        text: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.DocumentDraft.BannerReadMoreOnDocumentEmail
        ),
      }}
      useFullWidth={useFullWidth}
    />
  );
};

export default DocumentEmailBanner;
